import { Icon } from '@livable/saas-react-components';
import { Typography, Button, Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ExportStatementsModal from 'src/components/shared/ExportStatementsModal';
import PrintStatementsModal from 'src/components/shared/PrintStatementsModal';
import SendStatementsModal from 'src/components/statements/SendStatementsModal';
import useStyles from '../styles';
export default function StatementsActions() {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const sendStatementsModalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '428-StatementsBatchActions'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "mail-send"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.send')));
  const exportStatementsModalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '429-StatementsBatchActions'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.download')));
  const printStatementsModalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '430-StatementsBatchActions'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "print"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('general.print')));
  return /*#__PURE__*/React.createElement("div", {
    className: classes.actionsWrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('general.batch_actions')), /*#__PURE__*/React.createElement("div", {
    className: classes.desktopActions
  }, /*#__PURE__*/React.createElement(SendStatementsModal, {
    isIconTrigger: true
  }), /*#__PURE__*/React.createElement(ExportStatementsModal, {
    isIconTrigger: true
  }), /*#__PURE__*/React.createElement(PrintStatementsModal, {
    isIconTrigger: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.tabletActions
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 7,
    rowSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(SendStatementsModal, {
    trigger: sendStatementsModalTrigger
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ExportStatementsModal, {
    trigger: exportStatementsModalTrigger
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(PrintStatementsModal, {
    trigger: printStatementsModalTrigger
  })))));
}